import { Injectable      } from '@angular/core';
import { NotifierManager } from '../managers/notifier/notifier.manager';
import { Notifier        } from '../enums/notifier/notifier.enum';
import { NotifierMessage } from '../enums/notifier/message/notifier.enum';

@Injectable
({
  providedIn: 'root'
})
export class MessageError 
{
    constructor(private _notifier : NotifierManager) {}

    invalidMessageId()
    {
        this._notifier.show(Notifier.ERROR, NotifierMessage.MESSAGE_INVALID_MESSAGE_ID)
    }

    invalidDateSize()
    {
        this._notifier.show(Notifier.ERROR, NotifierMessage.MESSAGE_INVALID_DATE_SIZE)
    }
}